import Head from "next/head"
import React from "react"

import Footer from "~/components/organisms/Footer"
import AuthRegisterCompleteAdditionallyPage from "~/components/pages/AuthRegisterCompleteAdditionallyPage"

const RegisterCompleteAdditionally = () => {
  return (
    <>
      <Head>
        <title>新規登録完了 | Infra（インフラ）</title>
      </Head>
      <AuthRegisterCompleteAdditionallyPage />
      <Footer />
    </>
  )
}

export default RegisterCompleteAdditionally
